@if (_config.value()?.allow_file_uploads !== false || files().length > 0) {
  <div class="section">
    <div class="meta-header">
      <h3>{{ tablename }}s</h3>

      @if (
        flags?._can_upload_data &&
        !(dataset()?.dataset_type === 'REDCap') &&
        _config.value()?.allow_file_uploads !== false
      ) {
        <span class="action-button">
          <button mat-button class="add-button" type="button" (click)="show_upload_ui.set(true)">
            <mat-icon class="material-symbols-outlined">add</mat-icon>
            Add
          </button>
        </span>
      }
    </div>

    <div class="content-container">
      @if (show_upload_ui()) {
        <div class="add-new">
          <input
            type="file"
            #newFileInput
            class="hidden"
            (change)="newFile.set(newFileInput.files[0])"
            aria-labelledby="add-new-legend"
          />

          <div class="add-item-form">
            <div>
              <button matButton="filled" type="button" (click)="newFileInput.click()" [disabled]="isUploading()">
                <mat-icon class="material-symbols-outlined">attach_file</mat-icon>
                Browse Files...
              </button>
            </div>
            <div class="mat-column-document_type" [class.hidden]="!isProject()">
              <mat-form-field>
                <mat-label>Document Type</mat-label>
                <mat-select #newFileCategory [required]="true">
                  @for (cat of categories.value(); track cat.id) {
                    <mat-option [value]="cat.id">{{ cat.text }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            @if (newFile()) {
              <div class="pending-upload">
                {{ newFile().name }}
                <span class="ghost">
                  @if (isUploading()) {
                    (uploading, {{ uploadProgress() | percent: '1.2-2' }} complete)
                  } @else {
                    (pending upload)
                  }
                </span>
              </div>
            }
            <div class="mat-column-action_download">
              <button
                matButton="filled"
                type="button"
                (click)="onUpload(newFileCategory)"
                [disabled]="isUploading() || !newFile() || (isProject() && !newFileCategory.value)"
                [disabledInteractive]="hipaaScanInProgress()"
                [matTooltip]="
                  hipaaScanInProgress()
                    ? 'HIPAA scanning is in progress for the previous dataset file version.\n' +
                      'Please wait a few minutes, then refresh the page before adding a new dataset file version.'
                    : undefined
                "
              >
                <mat-icon class="material-symbols-outlined">upload</mat-icon>
                Upload
              </button>
            </div>
          </div>
        </div>
      }
      <div class="table-hugger">
        @if (files().length > 0) {
          <table mat-table class="mat-mdc-table rde-table" [dataSource]="filesObs">
            <ng-container matColumnDef="status_latest">
              <th mat-header-cell *matHeaderCellDef>Latest File</th>
              <td mat-cell *matCellDef="let file">
                @if (file.is_latest_and_not_deleted) {
                  <mat-icon class="material-symbols-outlined" [inline]="true" aria-label="Latest version"
                    >check</mat-icon
                  >
                }
              </td>
            </ng-container>
            <mat-text-column name="file_name" headerText="Filename"></mat-text-column>
            <mat-text-column name="file_size" headerText="File Size" [dataAccessor]="get_file_size"></mat-text-column>
            <mat-text-column
              name="category"
              headerText="Document Type"
              [dataAccessor]="get_document_type"
            ></mat-text-column>
            <mat-text-column
              name="time_created"
              headerText="Date Added"
              [dataAccessor]="get_date_created"
            ></mat-text-column>
            <mat-text-column
              name="uploaded_by"
              headerText="Uploaded By"
              [dataAccessor]="get_uploaded_by"
            ></mat-text-column>
            <ng-container matColumnDef="hipaa_status">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let file">
                @if (shouldDisplayHipaaWarning(file, dataset())) {
                  <span
                    class="hipaa-warning"
                    [matTooltip]="generateHipaaWarningTooltip(file)"
                    matTooltipClass="tooltip-warning"
                    >HIPAA WARNING</span
                  >
                } @else if (!file.is_scan_complete) {
                  <span class="hipaa-scanning">HIPAA SCANNING</span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="action_download">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let file">
                @if (
                  flags?._can_download_data ??
                  (flags?._can_download_all_data ||
                    (flags?._can_download_latest_data && file.is_latest_and_not_deleted))
                ) {
                  <button matButton="text" type="button" (click)="onDownload(file)">
                    <mat-icon class="material-symbols-outlined">download</mat-icon>
                    Download
                  </button>
                  @if (isProject() === false && file.file_name.endsWith('.csv')) {
                    <button
                      matButton="text"
                      type="button"
                      (click)="onDownload(file, {harmonizeDates: true})"
                      title="Hamonize the dates in this file during download"
                    >
                      <mat-icon class="material-symbols-outlined">download</mat-icon>
                      Harmonize Dates
                    </button>
                  }
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="action_delete">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let file">
                @if (flags?._can_delete_data) {
                  <button matButton="text" type="button" (click)="onDelete(file)">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    Delete
                  </button>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="getColumns()"></tr>
            <tr mat-row *matRowDef="let files; columns: getColumns()"></tr>
          </table>
        } @else {
          There are no files to display.
        }
      </div>
    </div>
  </div>

  <ng-template #hsd_download_attestation>
    By clicking "Yes" below, I confirm that I have reviewed the <a (click)="openDSP()">Data Security Plan</a> for
    <b>{{ dataset().name }}</b
    >. I am saving this file to a location listed on my DSP and approved for Highly Sensitive Data.
  </ng-template>

  <ng-template #non_hsd_download_attestation>
    By clicking "Yes" below, I confirm that this file for <b>{{ dataset().name }}</b> does NOT contain any highly
    sensitive data. I will save this file to an appropriate location as defined by organizational policy.
  </ng-template>
}
